const clientSatisfaction = {
    title: "درجة رضا العملاء",
    desc: "نحن نقدر مساعدتك في مساعدتنا على تحسين خدماتنا. يُرجى إكمال استبيان رضا العملاء وتقديم ملاحظاتك لتمكيننا من خدمتك بشكل أفضل في المستقبل.",
    score: {
        important: "الأهمية",
        score: "الدرجة",
        total: "المجموع",
        suggestionsComments: "الاقتراحات / التعليقات",
    },
    criteria: {
        serviceQuality: "جودة الخدمة",
        speedResponse: "سرعة الاستجابة",
        compliance: "الامتثال",
        definingRequests: "تعريف الطلبات",
        financeDepartment: "قسم المالية",
        priceTerms: "شروط السعر",
        complaintResolution: "حل الشكاوى",
        complaintWay: "طريقة الشكاوى",
        attentionToDetail: "الاهتمام بالتفاصيل",
    },
    placeholders: {
        writeDescription: "اكتب وصفك هنا...",
    }

}

export default clientSatisfaction;
